export interface SearchRouter {
  goToNews(newsId: string): void;
  goToComment(newsId: string, commentId: string): void;
  goToSurvey(surveyId: string): void;
  goToCommunity(communityId: string, slug: string): void;
  goToCommunityPost(communityId: string, slug: string, postId: string): void;
  goToCommunityPostComment(
    communityId: string,
    slug: string,
    postId: string,
    commentId: string,
  ): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchRouter = Symbol('SearchRouter');
